import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

/**
 * TemplateEditorHeader Component
 *
 * Displays the header section with back button, title, and edit mode information.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isEditMode - Whether the editor is in edit mode
 * @param {string} props.versionId - Version ID if editing a specific version
 * @param {Function} props.onCancel - Callback for cancel/back button
 */
const TemplateEditorHeader = ({ isEditMode, versionId, onCancel }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: 3,
      }}
    >
      <IconButton onClick={onCancel} sx={{ mr: 2 }}>
        <ArrowBackIcon />
      </IconButton>
      <Box>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          {isEditMode ? 'Edit Template' : 'Create New Template'}
        </Typography>
        {isEditMode && (
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            {versionId
              ? `Editing version ${versionId.slice(0, 8)}... - This will create a new version`
              : 'This will create a new version of the template'}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default TemplateEditorHeader;
